import { render, staticRenderFns } from "./RegisterTerms.vue?vue&type=template&id=756d090f&"
import script from "./RegisterTerms.vue?vue&type=script&lang=js&"
export * from "./RegisterTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports